module.exports = __webpack_public_path__ + "img/s-mock-assess.ca7830b9.svg";